import { render, staticRenderFns } from "./ListSOandFuturePayments.vue?vue&type=template&id=2494ce40"
import script from "./ListSOandFuturePayments.vue?vue&type=script&lang=js"
export * from "./ListSOandFuturePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports